export function useObjectHelpers() {

  const deepCloneObject = (object) => {
    return JSON.parse(JSON.stringify(object))
  }

  /**
   * Compares the data of 2 objects, allowing us to check if their contents are
   * equal via json serialization as javascript object comparison does not
   * check that.
   */
  const objectSerializationsAreEqual = (objectA, objectB) => {
    return JSON.stringify(objectA) === JSON.stringify(objectB)
  }

  return {
    deepCloneObject,
    objectSerializationsAreEqual
  }
}